import axios from "axios";

// Plain axios — no auth header; these are public endpoints
const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

export const getSignSession = (token) =>
    axios.get(`${API_BASE}/Sign/${token}`);

export const submitSignature = (token, { signaturePng, signedByName, salesPersonSignaturePng }) =>
    axios.post(`${API_BASE}/Sign/${token}`, { signaturePng, signedByName, salesPersonSignaturePng });
